import { CourseSelection } from '@/components/entityDropdowns/CourseSelection.tsx'
import { MultipassProductSelection } from '@/components/entityDropdowns/MultipassProductSelection.tsx'
import { TagSelection } from '@/components/entityDropdowns/TagSelection.tsx'
import Dynamic from '@/components/modals/dynamic.tsx'
import { popAllModals } from '@/components/modals/index.tsx'
import useOrganization from '@/hooks/organization/useOrganization.tsx'
import { Button } from '@/shadcn/components/ui/button.tsx'
import { DialogDescription, DialogHeader, DialogTitle } from '@/shadcn/components/ui/dialog.tsx'
import { Input } from '@/shadcn/components/ui/input.tsx'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shadcn/components/ui/tabs.tsx'
import {
  ToastVariant,
  copyBookingLinkToClipboard,
  createBookingLink,
  sendNotification,
} from '@/utils.tsx'
import { Calendar, Copy, Link2, Loader2, Tag, Ticket } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CourseEntity, MultipassProductEntity, TagEntity } from '../../../qourses-api-client'

export function CreateBookingLinkModal() {
  const { t: translate } = useTranslation()
  const { organization } = useOrganization()

  const [selectedCourse, setSelectedCourse] = useState<CourseEntity>(undefined)
  // const [selectedBookable, setSelectedBookable] =
  //   useState<IdentifiableBookableBackoffice>(undefined)
  const [selectedMultipassProduct, setSelectedMultipassProduct] =
    useState<MultipassProductEntity>(undefined)
  const [selectedTag, setSelectedTag] = useState<TagEntity>(undefined)
  const [submitting] = useState(false)

  // organization.id,
  //   selectedCourse ? selectedCourse.id : undefined,
  //   '',
  //   selectedTag ? selectedTag.id : undefined,
  //   selectedMultipassProduct ? selectedMultipassProduct.id : undefined,
  //   includeDetails,
  //   includeLocation,
  //   includeInstructor,

  const handleCreateBookingLink = () => {
    copyBookingLinkToClipboard({
      organizationSlug: organization.slug,
      organizationId: organization.id,
      courseId: selectedCourse ? selectedCourse.id : undefined,
      tagId: selectedTag ? selectedTag.id : undefined,
      multipassProductId: selectedMultipassProduct ? selectedMultipassProduct.id : undefined,
    })
    popAllModals()
    sendNotification(
      translate('modals.createBookingLinkModal.notification.title'),
      translate('modals.createBookingLinkModal.notification.subtitle'),
      ToastVariant.Success,
    )
  }

  const handlePreviewBookingLink = () => {
    createBookingLink({
      organizationSlug: organization.slug,
      organizationId: organization.id,
      courseId: selectedCourse ? selectedCourse.id : undefined,
      tagId: selectedTag ? selectedTag.id : undefined,
      multipassProductId: selectedMultipassProduct ? selectedMultipassProduct.id : undefined,
      newTab: true,
    })
    popAllModals()
  }

  const bookingLinkPreview = createBookingLink({
    organizationSlug: organization.slug,
    organizationId: organization.id,
    courseId: selectedCourse ? selectedCourse.id : undefined,
    tagId: selectedTag ? selectedTag.id : undefined,
    multipassProductId: selectedMultipassProduct ? selectedMultipassProduct.id : undefined,
  })?.toString()

  return (
    <Dynamic.Content className="p-4 sm:p-8">
      <div className="h-[80vh] overflow-y-auto p-2 sm:h-auto sm:overflow-auto sm:p-0">
        <DialogHeader className="mb-2">
          <DialogTitle className="mt-6 sm:mt-2">
            {translate('modals.createBookingLinkModal.title')}
          </DialogTitle>
          <DialogDescription>
            {translate('modals.createBookingLinkModal.subtitle')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col justify-end gap-y-4">
          <Tabs
            defaultValue={'courses'}
            className="mt-4 w-full"
            onValueChange={() => {
              // reset the selected values when the tab changes
              setSelectedCourse(undefined)
              setSelectedTag(undefined)
              setSelectedMultipassProduct(undefined)
            }}
          >
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="courses" className="truncate">
                <Calendar className="mr-1 size-4" />
                {translate('modals.createBookingLinkModal.tabs.courses')}
              </TabsTrigger>
              <TabsTrigger value="tags" className="truncate">
                <Tag className="mr-1 size-4" />
                {translate('modals.createBookingLinkModal.tabs.tags')}
              </TabsTrigger>
              <TabsTrigger value="multipassProducts">
                <Ticket className="mr-1 size-4" />
                {translate('modals.createBookingLinkModal.tabs.multipassProducts')}
              </TabsTrigger>
            </TabsList>
            <TabsContent value={'courses'}>
              <div className="p-2">
                <label className="mb-2 flex items-center text-sm font-medium text-gray-700">
                  <Calendar className="mr-1 size-3" />
                  {translate('modals.createBookingLinkModal.course.label')}
                </label>
                <CourseSelection
                  selectedCourse={selectedCourse}
                  setSelectedCourse={setSelectedCourse}
                  disabled={false}
                />
                <p className="mt-1 text-sm text-muted-foreground">
                  {translate('modals.createBookingLinkModal.course.subtitle')}
                </p>
              </div>
            </TabsContent>
            <TabsContent value={'tags'}>
              <div className="p-2">
                <label className="mb-2 flex items-center text-sm font-medium text-gray-700">
                  <Tag className="mr-1 size-3" />
                  {translate('modals.createBookingLinkModal.tag.label')}
                </label>
                <TagSelection
                  selectedTag={selectedTag}
                  setSelectedTag={setSelectedTag}
                  disabled={false}
                />
                <p className="mt-1 text-sm text-muted-foreground">
                  {translate('modals.createBookingLinkModal.tag.subtitle')}
                </p>
              </div>
            </TabsContent>
            <TabsContent value={'multipassProducts'}>
              <div className="p-2">
                <label className="mb-2 flex items-center text-sm font-medium text-gray-700">
                  <Ticket className="mr-1 size-3" />
                  {translate('modals.createBookingLinkModal.multipass.label')}
                </label>
                <MultipassProductSelection
                  selectedMultipassProduct={selectedMultipassProduct}
                  setSelectedMultipassProduct={setSelectedMultipassProduct}
                  disabled={false}
                />
                <p className="mt-1 text-sm text-muted-foreground">
                  {translate('modals.createBookingLinkModal.multipass.subtitle')}
                </p>
              </div>
            </TabsContent>
          </Tabs>

          {/*{selectedCourse && (*/}
          {/*  <div className="p-2">*/}
          {/*    <label className="mb-2 text-sm font-medium text-gray-700 flex items-center">*/}
          {/*      <SquareStack className="size-3 mr-1" />*/}
          {/*      {translate('modals.createBookingLinkModal.bookable.label')}*/}
          {/*    </label>*/}
          {/*    <CourseBookableSelection*/}
          {/*      courseId={selectedCourse.id}*/}
          {/*      selectedBookable={selectedBookable}*/}
          {/*      setSelectedBookable={setSelectedBookable}*/}
          {/*      disabled={!selectedCourse}*/}
          {/*    />*/}
          {/*    <p className="mt-1 text-sm text-muted-foreground">*/}
          {/*      {translate('modals.createBookingLinkModal.bookable.subtitle')}*/}
          {/*    </p>*/}
          {/*  </div>*/}
          {/*)}*/}
          <div className="p-2">
            <label className="mb-2 flex items-center text-sm font-medium text-gray-700">
              <Link2 className="mr-1 size-3" />
              {translate('modals.createBookingLinkModal.linkPreview.label')}
            </label>
            <Input
              disabled={true}
              onClick={() => {
                handleCreateBookingLink()
              }}
              value={bookingLinkPreview}
            />
            <ul className="list-disc text-sm text-muted-foreground list-inside mt-2">
              <p>{translate('modals.createBookingLinkModal.linkPreview.title')}</p>
              <li>
                {translate('modals.createBookingLinkModal.linkPreview.selectedOrganization', {
                  organizationName: organization.name,
                })}
              </li>
              {selectedCourse && (
                <li>
                  {translate('modals.createBookingLinkModal.linkPreview.selectedCourse', {
                    course: selectedCourse.name,
                  })}
                </li>
              )}
              {selectedTag && (
                <li>
                  {translate('modals.createBookingLinkModal.linkPreview.selectedTag', {
                    tag: selectedTag.name,
                  })}
                </li>
              )}
              {selectedMultipassProduct && (
                <li>
                  {translate('modals.createBookingLinkModal.linkPreview.selectedMultipass', {
                    multipass: selectedMultipassProduct.name,
                  })}
                </li>
              )}
              {bookingLinkPreview.includes('/s/') && (
                <li className="font-semibold">
                  {translate('modals.createBookingLinkModal.linkPreview.usesShorty')}
                </li>
              )}
            </ul>
          </div>
          <div className="flex flex-1 flex-wrap gap-y-4 mt-2">
            <Button
              variant="indigo"
              className="mr-2  flex flex-1"
              onClick={handleCreateBookingLink}
            >
              {submitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  {translate('common.loading')}
                </>
              ) : (
                <>
                  <Copy className="mr-2 size-4" />
                  {translate('modals.createBookingLinkModal.button')}
                </>
              )}
            </Button>
            <Button
              variant="secondary"
              className="mr-2 flex flex-1"
              onClick={handlePreviewBookingLink}
            >
              <Copy className="mr-2 size-4" />
              {translate('modals.createBookingLinkModal.previewButton')}
            </Button>
          </div>
        </div>
      </div>
    </Dynamic.Content>
  )
}
